module.exports = __webpack_public_path__ + "img/teacheravater.631cdafd.png";